var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticStyle:{"height":"calc(100vh - 300px)"}},[_c('pdfview',{attrs:{"pdfUrl":_vm.pdfUrl}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }